import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NotFound() {
    const location = useLocation();

    return (
        <div className="container mx-auto px-4 py-16">
            <div className="mx-auto max-w-xl text-center">
                <p className="text-6xl font-bold text-blue-600 dark:text-blue-400">404</p>
                <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">Page introuvable</h1>
                <p className="mt-3 text-gray-600 dark:text-gray-400">
                    La page <span className="font-mono text-sm">{location.pathname}</span> n'existe pas.
                </p>
                <div className="mt-8 flex flex-row flex-wrap gap-3 justify-center">
                    <Link
                        to="/"
                        className="inline-block bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors duration-200 font-semibold"
                    >
                        Accueil
                    </Link>
                    <Link
                        to="/processor"
                        className="inline-block px-5 py-2 rounded-lg border border-blue-500 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-gray-800 transition-colors duration-200 font-semibold"
                    >
                        Déposer un fichier
                    </Link>
                    <Link
                        to="/processor/history"
                        className="inline-block px-5 py-2 rounded-lg border border-blue-500 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-gray-800 transition-colors duration-200 font-semibold"
                    >
                        Historique
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
